/**
 * Cột KT và Định lượng của dòng PO kiểu cũ (không có bảng tính): tách quy cách "1000x50x50x10"
 * thành KT1…KTn, lấy định lượng và màu từ thuộc tính dòng. Cùng quy tắc với máy chủ (legacyMappings).
 */
import { displayCell } from '@/lib/cellDisplay'

export function legacySpecParts(spec: unknown): string[] {
  if (typeof spec !== 'string' || spec.trim() === '') return []
  return spec.split(/x/i).map((s) => s.trim()).filter((s) => s !== '')
}

/** Tên cột lọc theo các dòng: KT1…KTn theo số lớn nhất, rồi Định lượng nếu có dòng nào có định lượng. */
export function legacyColumnNames(lines: Array<{ spec?: unknown; density?: unknown }>): string[] {
  const maxKt = lines.reduce((m, l) => Math.max(m, legacySpecParts(l.spec).length), 0)
  const out: string[] = []
  for (let i = 1; i <= maxKt; i++) out.push('KT' + i)
  if (lines.some((l) => l.density !== undefined && l.density !== null && String(l.density).trim() !== '')) out.push('Định lượng')
  return out
}

/** Chữ hiển thị của một cột kiểu cũ trong một dòng; ô không có giá trị để trống. */
export function legacyCellValue(attrs: Record<string, unknown> | null | undefined, column: string): string {
  const a = attrs ?? {}
  const kt = /^KT(\d+)$/.exec(column)
  if (kt) return displayCell(legacySpecParts(a.spec)[Number(kt[1]) - 1])
  if (column === 'Định lượng') return displayCell(a.density)
  return ''
}
